import { FinancialPortal } from '@generated-gql/generated-types';

export const PortalProductState = {
  RETRIEVAL_IN_PROGRESS: 'RETRIEVAL_IN_PROGRESS',
  DATA_RETRIEVED: 'DATA_RETRIEVED',
};

export const isRefreshing = (portal: FinancialPortal) => {
  return (
    portal?.isRefreshing ||
    portal?.accountsState === PortalProductState.RETRIEVAL_IN_PROGRESS ||
    portal?.transactionsState === PortalProductState.RETRIEVAL_IN_PROGRESS
  );
};

export const isSyncing = (portal: FinancialPortal) => {
  return (
    portal?.migrationDetails?.hasUserConfirmed ||
    portal?.isActiveSync ||
    portal?.isRefreshing
  );
};
